<template>
  <v-layout row wrap>
    <v-flex xs5>
      <v-menu
        lazy
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        full-width
        :nudge-left="40"
        max-width="290px"
        v-model="active"
        ref="datepicker"
        :disabled="disabled">
        <v-text-field
          slot="activator"
          :label="label"
          v-model="formattedDate"
          :error="errorMessages.length > 0"
          readonly
          :disabled="disabled"></v-text-field>
        <v-date-picker :allowed-dates="allowedDates" v-model="date" :first-day-of-week="firstDayOfWeek" no-title scrollable></v-date-picker>
      </v-menu>
    </v-flex>
    <v-flex xs7>
      <v-text-field
        label=""

        v-model="time" :placeholder="placeholderTime" v-mask="timeFormatMask" @click="clickTime" :disabled="disabled" :error-messages="errorMessages">
          <template slot="append">
            <template v-for="(button, i) in timeButtons">
              <v-btn @click="setTime(button)" flat small style="min-width: 20px; margin: 0px; padding: 0px 4px;" :style="{'margin-right': (i+1 == timeButtons.length) ? '3px' : 0}" :title="button.text">
                <v-icon v-if="button.icon">
                  {{button.icon}}
                </v-icon>
                <span v-else-if="button.text && button.text.length > 0">
                  {{button.text}}
                </span>
              </v-btn>
            </template>
          </template>
        </v-text-field>
    </v-flex>
  </v-layout>
</template>

<script>
import moment from 'moment';

export default {
  props: {
    value: Date,
    'date-format': {type: String, default: "DD.MM.YYYY"},
    'time-format': {type: String, default: "HH:mm:ss"},
    'first-day-of-week': {type: String, default: "0"},
    label: String,
    'disabled-before': Date,
    'disabled-after': Date,
    'disabled': {type: Boolean, default: false},
    'time-buttons': {type: Array, default: () => []},
    'rules': {type: Array, default: () => []},
    'clear-time': {type: Boolean, default: false},
    'modified': {type: Boolean, default: false}
  },
  data() {
    return {
      active: false,
      lastPicker: "DATE",
      watcher: undefined,
      errorMessages: [],
      dateModified: false,
      timeModified: false
    }
  },
  watch: {
    active (val) {
      if(val) {
        this.$nextTick(() => {
          this.watcher = this.$watch(() => {
            return this.$refs.datepicker.$children[1].activePicker // TODO: KORJAA PURKKA
          },
          (val) => {
            this.lastPicker = val;
          })
        })
      } else if (typeof(this.watcher) == "function") {
        this.watcher();
      }
    },
    value (newVal, oldVal) {
      if(this.lastPicker == "DATE") {
        this.active = false;
      }
    }
  },
  created() {
    this.validate();
  },
  methods: {
    validate(value) {
      this.errorMessages = [];
      if(this.clearTime && !this.timeModified) {
        this.errorMessages.push("Time cannot be empty");
      }
      this.rules.forEach(rule => {
        if(typeof(rule) == "function") {
          const result = rule(value || this.value);
          if(result !== true) {
            this.errorMessages.push(result);
          }
        }
      });
      return this.errorMessages.length === 0;
    },
    allowedDates (date) {
      if(typeof(this.disabledBefore) != "undefined" || typeof(this.disabledAfter) != "undefined") {
        return (typeof(this.disabledBefore) != "undefined" && moment(date).isSameOrAfter(this.disabledBefore,"day")) || (typeof(this.disabledAfter) != "undefined" && moment(date).isSameOrBefore(this.disabledAfter,"day"));
      }
      return true;
    },
    clickTime (event) {
      if(event.target.selectionStart <= 2) {
        event.target.setSelectionRange(0, 2);
      } else if(event.target.selectionStart <= 5) {
        event.target.setSelectionRange(3, 5);
      } else if(event.target.selectionStart <= 8) {
        event.target.setSelectionRange(6, 8);
      }
    },
    setTime (button) {
      if(button.action == "add") {
        var value = button.value;
        if(_.isFunction(button.to)) {
          var new_value = moment(button.to()).add(value, 'seconds').toDate();
        } else {
          var new_value = moment(this.value).add(value, 'seconds').toDate();
        }
      }
      if(button.action == "end_of_day") {
        var value = button.value;
        if(_.isFunction(button.to)) {
          var new_value = moment(button.to()).endOf('day').toDate();
        } else {
          var new_value = moment(this.value).endOf('day').toDate();
        }
      }
      if(button.action == "start_of_day") {
        var value = button.value;
        if(_.isFunction(button.to)) {
          var new_value = moment(button.to()).startOf('day').toDate();
        } else {
          var new_value = moment(this.value).startOf('day').toDate();
        }
      }
      this.$emit('input', new_value);
      this.timeModified = true;
      this.$emit('update:modified', true);
      this.validate(new_value);
    }
  },
  computed: {
    date: {
      get () {
        return moment(this.value).format();
      },
      set: _.debounce(function(val) {
        this.$emit('input', moment( moment(val).format(this.dateFormat) + " " + this.time, this.dateFormat+" "+this.timeFormat).toDate());
        this.dateModified = true;
        this.$emit('update:modified', true);
      }, 100)
    },
    formattedDate () {
      return moment(this.value).format(this.dateFormat);
    },
    timeFormatMask () {
      return this.timeFormat.replace(/H|m|s/g,"#");
    },
    placeholderTime () {
      if(!this.clearTime) return "";
      return moment(this.value).format(this.timeFormat);
    },
    time: {
      get () {
        if(this.clearTime && !this.timeModified) return "";
        return moment(this.value).format(this.timeFormat);
      },
      set: _.debounce(function(val) {
        if(/^(([0|1][0-9])|([2][0-3])):([0-5][0-9])$/.test(val)) {
          var new_value = moment(this.formattedDate + " " + val, this.dateFormat+" "+this.timeFormat).toDate();
          this.$emit('input', new_value);
          this.timeModified = true;
          this.$emit('update:modified', true);
          this.validate(new_value);
        } else {
          this.errorMessages.push("Invalid time format");
        }
      }, 250)
    }
  }
}
</script>
